// 🟢 FIXED: Separated createSlice (value) from PayloadAction (type)
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface QueueState {
  activeQueue: {
    expertCode: string;
    expertName: string;
    queueRank: number;
    mode: 'chat' | 'call' | 'video';
    intakeData: any;
  } | null;
  isMinimized: boolean;
}

// Automatically load from localStorage so it survives page refreshes!
const loadState = (): QueueState => {
  try {
    const serialized = localStorage.getItem('activeQueue');
    if (serialized) {
      return { activeQueue: JSON.parse(serialized), isMinimized: true };
    }
  } catch (e) {}
  return { activeQueue: null, isMinimized: false };
};

const initialState: QueueState = loadState();

export const queueSlice = createSlice({
  name: 'queue',
  initialState,
  reducers: {
    setQueue: (state, action: PayloadAction<NonNullable<QueueState['activeQueue']>>) => {
      state.activeQueue = action.payload;
      state.isMinimized = false;
      // Sync to localStorage
      localStorage.setItem('activeQueue', JSON.stringify(action.payload));
    },
    clearQueue: (state) => {
      state.activeQueue = null;
      state.isMinimized = false;
      // Clear from localStorage
      localStorage.removeItem('activeQueue');
    },
    setMinimized: (state, action: PayloadAction<boolean>) => {
      state.isMinimized = action.payload;
    }
  }
});

export const { setQueue, clearQueue, setMinimized } = queueSlice.actions;
export default queueSlice.reducer;